import { fieldset } from "@launchos/components/ui/theme"
export default {
  span: {
    cursor: 'text',
    display: 'inline-block',
  },
  fieldset,
};
